<template>
  <div class="energySankey mainPageBg">
    <div class="selectWrap commonWrap">
      <el-radio-group
        v-model="timeType"
        size="mini"
        style="margin: 0 20px"
        @change="getDataValue"
      >
        <el-radio-button label="DAY">按日</el-radio-button>
        <el-radio-button label="MONTH">按月</el-radio-button>
      </el-radio-group>
      <el-date-picker
        size="mini"
        v-model="timeValue"
        :clearable="false"
        :type="timeType == 'MONTH' ? 'month' : 'date'"
        :key="timeType == 'MONTH' ? 'month' : 'date'"
        :placeholder="timeType == 'MONTH' ? '选择月' : '选择日期'"
        :value-format="timeType == 'MONTH' ? 'yyyy-MM' : 'yyyy-MM-dd'"
      >
      </el-date-picker>
      <el-radio-group
        size="mini"
        v-model="radio"
        style="margin: 0 20px"
        @change="changetypeFiltering"
      >
        <el-radio-button label="单位部门">部门</el-radio-button>
        <el-radio-button label="分项系统">系统</el-radio-button>
        <el-radio-button label="区域位置">区域</el-radio-button>
      </el-radio-group>
      <el-cascader
        size="mini"
        :key="keyValue"
        v-model="defaultId"
        :options="dataList"
        :show-all-levels="false"
        :props="{
          checkStrictly: true,
          value: 'id',
          label: 'name',
          emitPath: false,
        }"
        :clearable="false"
      ></el-cascader>
      <el-button
        type="primary"
        @click="onSubmit"
        size="mini"
        style="margin-left: 20px"
        >查询</el-button
      >
    </div>
    <div class="commonWrap chartWrap">
      <PublicEcharts
        :id="'sankey'"
        :chartsData="chartsData"
        :type="'treeCharts'"
      />
    </div>
  </div>
</template>

<script>
import { dateFtt, arrayUnique } from "@/assets/js/utils";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
export default {
  components: {
    PublicEcharts,
  },
  data() {
    return {
      timeType: "DAY",
      timeValue: new Date(),
      keyValue: 0,
      radio: "单位部门",
      treeAllData: [],
      dataList: [],
      defaultData: {},
      defaultId: null,
      chartsData: [],
    };
  },
  watch: {
    dataList(newVal) {
      this.keyValue++; //只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
    },
  },
  methods: {
    async onSubmit() {
      this.chartsData = [];
      let res = await api.energySankeyData({
        assetId: this.defaultId,
        option: "HasEUDevice",
        maxLevel: 4,
        type: this.timeType,
        date: this.timeValue,
        label: "用能设备",
        assetType: this.radio,
        deviceTypes: "电表",
      });
      if (res && res.status == 200) {
        if (!res.data.name) {
          this.$message.error("未查询到数据!");
          return;
        }
        this.chartsData.push(res.data);
      }
    },

    getAsseList() {
      this.treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.dataList = [this.treeAllData[this.radio]];
      this.defaultData = this.dataList[0];
      // this.calleArr(this.dataList);
      this.$nextTick(() => {
        this.defaultId = this.defaultData.id;
        this.onSubmit();
      });
    },
    // 获取区域筛选变化
    changetypeFiltering() {
      this.dataList = [this.treeAllData[this.radio]];
      this.defaultData = this.dataList[0];
      this.$nextTick(() => {
        this.defaultId = this.defaultData.id;
      });
    },
    calleArr(array) {
      let _this = this;
      let data = array[0];
      if (data.children) {
        _this.calleArr(data.children);
      } else {
        _this.defaultData = data;
      }
    },
    getDataValue() {
      if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
      } else if (this.timeType == "DAY") {
        this.timeValue = dateFtt("yyyy-MM-dd", new Date());
      } else {
        this.timeValue = null;
      }
    },
  },
  created() {
    this.getDataValue();
    this.getAsseList();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.energySankey {
  // @include setPage;
  .selectWrap {
    width: 100%;
    height: 60px;
    margin-bottom: 12px;
    @include setFlexStart;
  }
  .chartWrap {
    width: 100%;
    height: calc(100% - 72px);
  }
}
</style>
